module.exports = __webpack_public_path__ + "img/4f372c6545e6176b128ccf3da75a013b.ee766d7b.png";